import Vue from 'vue'
import App from './App'
import { router } from './router'
import store from './vuex'
import b64 from '@/utils/base64.js';
import request from './utils/request.js' // 引入请求方法
import * as api from './utils/api.js' // 引入接口地址
import sessionStorage from './utils/sessionStorage.js';//session工具
import i18n from './vuex/i18n/i18n.js';

import 'babel-polyfill'             // 低版本IE兼容axios
import promise from 'es6-promise'   // 手机端安卓低版本兼容axios
import './common/js/rem.js'   // 监听resize动态适配
/**这个库会在桌面端自动将 mouse 事件转换成对应的 touch 事件，使得组件能够在桌面端使用。 */
import '@vant/touch-emulator';
// 按需引入vant组件
import '@/plugin/vant'
// 引入vant组件样式
import 'vant/lib/index.css';
// 引入移动端适配
import 'lib-flexible/flexible.js'
// import '@icon-park/vue/styles/index.css' // 图签库
import components from '@/components/common/index.js'
// import Vconsole from 'vconsole';
// let vconsole = new Vconsole;
// vconsole;
Vue.use(components);//全局注册组件
Vue.prototype['$request'] = request; // 注册全局请求方法
Vue.prototype['$sessionStorage'] = sessionStorage; // 注册全局请求方法
Vue.prototype['$Base64'] = new b64();; // 注册全局
Vue.prototype['$api'] = api; // 注册全局接口地址
promise.polyfill();
Vue.config.productionTip = false;
new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js